const position = (event) => ({ x: event.pageX, y: event.pageY });
const getOffsets = (event, startPos) => {
    const newPos = position(event);
    return {
        x: newPos.x - startPos.x,
        y: newPos.y - startPos.y,
    };
};
const getDirections = (offsets) => ({
    left: offsets.x <= 0 ? Math.abs(offsets.x) : 0,
    right: offsets.x >= 0 ? Math.abs(offsets.x) : 0,
    up: offsets.y <= 0 ? Math.abs(offsets.y) : 0,
    down: offsets.y >= 0 ? Math.abs(offsets.y) : 0,
});
const order = (directions) => {
    return Object.keys(directions).sort((a, b) => directions[b] - directions[a]);
};

const swipeEvents = (element, options = {}) => {
    const minDistance = options.minDistance || 100;
    const maxTime = options.maxTime || 500;

    let didDown;
    let didSwipe;
    let startTime;
    let startPos;

    if (!options.touch && !options.mouse) {
        return;
    }

    const down = (event) => {
        event.preventDefault();
        didDown = true;
        startTime = Date.now();
        startPos = position(event);
    };

    const move = (event) => {
        event.preventDefault();
        if (!didDown) {
            return;
        }
        didSwipe = true;
        const offsets = getOffsets(event, startPos);
        const directions = getDirections(offsets);
        const direction = order(directions)[0];
        const distance = directions[direction];

        element.dispatchEvent(
            new CustomEvent("swipe", {
                bubbles: true,
                cancelable: true,
                detail: {
                    direction,
                    distance,
                    offsets,
                },
            })
        );
    };

    const up = (event) => {
        event.preventDefault();
        didDown = false;
        if (!didSwipe) {
            return;
        }
        didSwipe = false;

        const elapsedTime = Date.now() - startTime;
        if (elapsedTime <= maxTime) {
            const offsets = getOffsets(event, startPos);
            const directions = getDirections(offsets);
            const direction = order(directions)[0];
            const distance = directions[direction];

            if (distance >= minDistance) {
                element.dispatchEvent(
                    new CustomEvent("swiped", {
                        bubbles: true,
                        cancelable: true,
                        detail: {
                            direction,
                            distance,
                            offsets,
                            elapsedTime,
                        },
                    })
                );
            }
        }
    };

    // Add event listeners
    if (options.touch) {
        element.addEventListener("touchstart", (event) => down(event));
        element.addEventListener("touchmove", (event) => move(event));
        element.addEventListener("touchend", (event) => up(event));
    }
    if (options.mouse) {
        element.addEventListener("mousedown", (event) => down(event));
        document.addEventListener("mousemove", (event) => move(event));
        document.addEventListener("mouseup", (event) => up(event));
    }
};

export default swipeEvents;
